import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

interface LaunchGateProps {
  onUnlock: () => void;
}

const LaunchGate: React.FC<LaunchGateProps> = ({ onUnlock }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (password === 'crv') {
      onUnlock();
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <div className="create-blootbox-section" style={{ maxWidth: '600px', margin: '0 auto', marginTop: '100px' }}>
      <div className="section-header">
        <h3>Access Protocol</h3>
        <p className="section-desc">
          Enter your access code to enter the Bloot terminal.
        </p>
      </div>

      <div className="blootbox-form">
        <div className="form-group">
          <label>Access Code</label>
          <input
            type="password"
            placeholder="Enter code..."
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            className="bloot-input"
            autoFocus
          />
        </div>

        {error && (
          <div style={{
            padding: '12px',
            background: 'rgba(255, 0, 0, 0.1)',
            border: '1px solid #FF0000',
            borderRadius: '4px',
            color: '#FF0000',
            fontSize: '0.875rem'
          }}>
            {error}
          </div>
        )}

        <button
          onClick={() => handleSubmit()}
          className="deploy-btn"
        >
          Initialize <ArrowRight size={20} style={{ marginLeft: '8px', display: 'inline-block', verticalAlign: 'middle' }} />
        </button>
      </div>
    </div>
  );
};

export default LaunchGate;


